import { CommonModule as NgCommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxMaskDirective, NgxMaskPipe } from "ngx-mask";
import { AppModule } from "./app/app.module";
import { AutocompleteComponent } from "./autocomplete/autocomplete.component";
import { AvatarIconComponent } from "./avatar-icon/avatar-icon.component";
import { ChartModule } from "./chart/chart.module";
import { DatepickerComponent } from "./datepicker/datepicker.component";
import { BaseDialogComponent } from "./dialog/base-dialog/base-dialog.component";
import { BaseFilterDialogComponent } from "./dialog/base-filter-dialog/base-filter-dialog.component";
import { BaseFilterFullRowItemDirective } from "./dialog/base-filter-dialog/base-filter-full-row-item.directive";
import { BaseFilterItemDirective } from "./dialog/base-filter-dialog/base-filter-item.directive";
import { DialogHtml } from "./dialog/html/dialog-html.component";
import { SecurityInfoDialogComponent } from "./dialog/security-info-dialog/security-info-dialog.component";
import { SimpleDialogComponent } from "./dialog/simple-dialog/simple-dialog.component";
import { FilterParamAmountRangeInputComponent } from "./filter/filter-param-amount-range-input/filter-param-amount-range-input.component";
import { FilterParamDateRangeInputComponent } from "./filter/filter-param-date-range-input/filter-param-date-range-input.component";
import { FiltersActiveListModule } from "./filter/filters-active-list/filters-active-list.module";
import { FinanceContactWidgetComponent } from "./finance-contact/finance-contact-widget.component";
import { HorizontalListCustomTemplateDirective } from "./horizontal-list/horizontal-list-custom-template.directive";
import { MobileAppBannerComponent } from "./mobile-app-banner/mobile-app-banner.component";
import { HorizontalListComponent } from "./horizontal-list/horizontal-list.component";
import { SimpleHorizontalListWidgetComponent } from "./horizontal-list/simple-horizontal-list-widget/simple-horizontal-list-widget.component";
import { MaterialModule } from "./material/material.module";
import { PipesModule } from "./pipes/pipes.module";
import { SslInfoComponent } from "./ssl-info/ssl-info.component";
import { StatusLabelComponent } from "./status-label/status-label.component";
import { SvgsModule } from "./svgs/svgs.module";

@NgModule({
  imports: [
    RouterModule,
    NgCommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AppModule,
    ChartModule,
    SvgsModule,
    FlexLayoutModule,
    PipesModule,
    FiltersActiveListModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  declarations: [
    DialogHtml,
    StatusLabelComponent,
    FilterParamDateRangeInputComponent,
    FilterParamAmountRangeInputComponent,
    DatepickerComponent,
    SecurityInfoDialogComponent,
    AvatarIconComponent,
    SslInfoComponent,
    AutocompleteComponent,
    BaseDialogComponent,
    SimpleDialogComponent,
    BaseFilterDialogComponent,
    BaseFilterFullRowItemDirective,
    BaseFilterItemDirective,
    FinanceContactWidgetComponent,
    HorizontalListComponent,
    HorizontalListCustomTemplateDirective,
    SimpleHorizontalListWidgetComponent,
    MobileAppBannerComponent
  ],
  exports: [
    NgCommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ChartModule,
    SvgsModule,
    AppModule,
    DialogHtml,
    StatusLabelComponent,
    PipesModule,
    FilterParamDateRangeInputComponent,
    FilterParamAmountRangeInputComponent,
    FiltersActiveListModule,
    DatepickerComponent,
    AvatarIconComponent,
    SslInfoComponent,
    AutocompleteComponent,
    FlexLayoutModule,
    NgxMaskDirective,
    NgxMaskPipe,
    BaseDialogComponent,
    SimpleDialogComponent,
    BaseFilterDialogComponent,
    BaseFilterFullRowItemDirective,
    BaseFilterItemDirective,
    FinanceContactWidgetComponent,
    HorizontalListComponent,
    HorizontalListCustomTemplateDirective,
    SimpleHorizontalListWidgetComponent,
    MobileAppBannerComponent
  ],
})
export class UiModule {}
